export default (theme) => ({
    root: {
        display: 'inline-block',
    },
    Popover: {
        '& .hoi-poi-popover-inner': {
            width: 279,
            padding: 0,
            borderRadius: 8,
            overflow: 'hidden',
            boxShadow: theme.effects.boxShadow,
        },
    },
    chip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        minHeight: 24,
        padding: '4px 8px',
        borderRadius: 25,
        border: '1px solid transparent',
        outline: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease',
        boxSizing: 'border-box',
        '&$chipDisabled': {
            cursor: 'not-allowed',
            opacity: 0.5,
        },
    },
    chipSurface: {
        backgroundColor: 'var(--select-chip-bg-color)',
        borderColor: 'var(--select-chip-border-color)',
        '&$chipHovered': {
            backgroundColor: 'var(--select-chip-hover-bg-color)',
        },
        '&$chipOpen': {
            borderColor: 'var(--select-chip-open-border-color)',
        },
    },
    chipHovered: {},
    chipOpen: {},
    chipDisabled: {},
    chipText: {
        lineHeight: 1,
    },
    chipIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 10,
        transition: 'transform 150ms ease',
        '&$chipIconOpen': {
            transform: 'rotate(180deg)',
        },
    },
    chipIconOpen: {},
    dropdownRoot: {
        padding: '8px 16px',
        backgroundColor: theme.colors.primary.white,
    },
    dropdownTitle: {
        ...theme.typography.h6,
        minHeight: 36,
        padding: '0 12px',
        display: 'flex',
        alignItems: 'center',
        color: theme.colors.actionMinor[600],
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        minHeight: 36,
        padding: '0 12px',
        borderRadius: 4,
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        boxSizing: 'border-box',
        '&$optionDisabled': {
            cursor: 'not-allowed',
            opacity: 0.5,
        },
    },
    optionSelected: {
        backgroundColor: theme.colors.background.utility025,
        '&$optionHovered': {
            backgroundColor: theme.colors.background.utility025,
        },
    },
    optionHovered: {
        backgroundColor: theme.colors.grey[50],
    },
    optionDisabled: {},
    optionAvatar: {
        width: 22,
        minWidth: 22,
        height: 22,
        minHeight: 22,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        borderRadius: 4,
        backgroundColor: theme.colors.actionMinor[100],
    },
    optionAvatarIcon: {
        display: 'flex',
        flexShrink: 0,
    },
    optionText: {
        flex: 1,
        lineHeight: 1,
        color: theme.colors.textLight.primary,
    },
    optionCheckIcon: {
        flexShrink: 0,
    },
});
